import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ProjectFAQs  from './ProjectFAQs';
import { device } from 'utils';

export default function ProjectTab(props) {
  const {
    project,
  } = props;
  const projectFaq =
    project.faq ||
    (project.projectDescription && project.projectDescription.faq) ||
    [];

  return (
    <ProjectTabWrapper>
      <MobilePatternProjectInfo
        src="/mobile-project-pattern-info.svg"
        loading="lazy"
        alt=""
        aria-hidden="true"
      />
      <ProjectTabContent className="project__details">
        <ProjectFAQs
          projectFaq={projectFaq}
          isTicketable={project.is_ticketable}
          isPatreon={project.is_patreon}
        />
      </ProjectTabContent>
    </ProjectTabWrapper>
  );
}

ProjectTab.propTypes = {
  match: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  isViewPage: PropTypes.bool.isRequired,
  handelShowModal: PropTypes.func,
  updates: PropTypes.array.isRequired,
  loadingDonations: PropTypes.bool.isRequired,
  getProjectDonations: PropTypes.func.isRequired,
  donations: PropTypes.object.isRequired,
};

const ProjectTabWrapper = styled.div`
  position: relative;
  width: 100%;
  justify-content: center;
  display: flex;
  gap:24px;
  margin-top: 24px;
`

const ProjectTabContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 764px;
  gap: 24px;
  width: 100%;
`

const MobilePatternProjectInfo = styled.img`
  display: none;

  @media ${device.allMobile} {
    display: block;
    position: absolute;
    top: -100px;
    right: -20px;
    z-index: 0;
    width: 174px;
    max-width: 46vw;
    pointer-events: none;
  }
`;
